import * as i0 from "@angular/core";
/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var PlatformCommunicatorAuthService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @function sessionStorage.removeItem
     */
    function PlatformCommunicatorAuthService() {
        sessionStorage.removeItem('token-api');
        sessionStorage.removeItem('session-id');
        sessionStorage.removeItem('token-otp-jemelli');
    }
    /**
     * Función para guardar la información SSO en sessionStorage
     *
     * *Function to save SSO information in sessionStorage*
     *
     * @type {function}
     * @param {SSOInformation} ssoInformation
     */
    PlatformCommunicatorAuthService.prototype.saveSSOInformation = function (ssoInformation) {
        sessionStorage.setItem('token-api', JSON.stringify(ssoInformation));
    };
    /**
     * Función para obtener la información SSO desde sessionStorage
     *
     * *Function to obtain SSO information from sessionStorage*
     *
     * @type {function}
     */
    PlatformCommunicatorAuthService.prototype.getSSOInformation = function () {
        return JSON.parse(sessionStorage.getItem('token-api') || '{}');
    };
    /**
     * Función para guardar la sesion en sessionStorage
     *
     * *Function to save session information in sessionStorage*
     *
     * @type {function}
     * @param {SSOInformation} ssoInformation
     */
    PlatformCommunicatorAuthService.prototype.saveSessionId = function (sessionId) {
        sessionStorage.setItem('session-id', sessionId);
    };
    /**
     * Función para obtener la session desde sessionStorage
     *
     * *Function to obtain session information from sessionStorage*
     *
     * @type {function}
     */
    PlatformCommunicatorAuthService.prototype.getSessionId = function () {
        return sessionStorage.getItem('session-id') || '';
    };
    /**
     * Función para guardar la sesion en sessionStorage
     *
     * *Function to save session information in sessionStorage*
     *
     * @type {function}
     * @param {SSOInformation} ssoInformation
     */
    PlatformCommunicatorAuthService.prototype.saveSessionClientProduct = function (clientProduct) {
        sessionStorage.setItem('client-product', clientProduct);
    };
    /**
     * Función para obtener la session desde sessionStorage
     *
     * *Function to obtain session information from sessionStorage*
     *
     * @type {function}
     */
    PlatformCommunicatorAuthService.prototype.clientProduct = function () {
        return sessionStorage.getItem('client-product') || '';
    };
    PlatformCommunicatorAuthService.prototype.saveSSOTokenForOTP = function (ssoInformation) {
        sessionStorage.setItem('token-otp-jemelli', JSON.stringify(ssoInformation));
    };
    /**
     * Función para obtener la información SSO desde sessionStorage
     *
     * *Function to obtain SSO information from sessionStorage*
     *
     * @type {function}
     */
    PlatformCommunicatorAuthService.prototype.getSSOTokenForOTP = function () {
        return JSON.parse(sessionStorage.getItem('token-otp-jemelli') || '{}');
    };
    PlatformCommunicatorAuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlatformCommunicatorAuthService_Factory() { return new PlatformCommunicatorAuthService(); }, token: PlatformCommunicatorAuthService, providedIn: "root" });
    return PlatformCommunicatorAuthService;
}());
export { PlatformCommunicatorAuthService };
